import { Component, effect, inject, untracked } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { ScreenHandlerService } from './shared/services/screen-handler/screen-handler.service';
import { DesyNavModule } from 'desy-angular';
import { AuthenticationService } from './shared/services/authentication/authentication.service';
import { SharedStateService } from './shared/services/shared-state/shared-state.service';
import { NoticesComponent } from './shared/components/notices/notices.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, HeaderComponent, DesyNavModule, NoticesComponent]
})
export class AppComponent {
  protected readonly screenHandlerService = inject(ScreenHandlerService);
  private readonly sharedStateService = inject(SharedStateService);

  constructor() {
    effect(() => {
      if (AuthenticationService.User()) {
        untracked(() => this.sharedStateService.onLoginLoadStates());
      }
    });
  }
}
